import { images } from "./images";
import { Category, CategoryDetails, MetaTagsProps } from "@/types";
import { UserCheck } from "lucide-react";
import { OG_PATH, WEBSITE_URL } from "@/content";
import {
  createImageItems,
  guardingCategoryPoints,
} from "@/content/services/service-content-helpers";
import { category as service1, createMetaTags as tags1 } from "./1";
import { category as service2, createMetaTags as tags2 } from "./2";
import { category as service3, createMetaTags as tags3 } from "./3";
import { category as service4, createMetaTags as tags4 } from "./4";
import { category as service5, createMetaTags as tags5 } from "./5";

const slug = "security-guarding-and-safety-services-sydney";

export const headCategory: Category = {
  id: 2,
  key: "guarding",
  name: "Security Guarding & Safety Services Sydney",
  long_name: "Security Guarding & Safety Services Sydney",
  slug,
  categoryType: "services",
};

export const metaTags: MetaTagsProps = {
  title: "Security Guarding & Safety Services Sydney | Ozy Wide Group",
  description:
    "Security guarding and safety support across Sydney, including licensed guards, mobile patrols, risk consultation, fire alarm support and security cabling. Ozy Wide Group scopes duties, access and reporting before recommending the right mix of people, systems and infrastructure.",
  keywords:
    "security guarding Sydney, mobile patrols Sydney, security guards Sydney, fire alarm systems Sydney, security consultation Sydney, security cabling Sydney",
  url: `${WEBSITE_URL}/${headCategory.categoryType}/${headCategory.slug}/`,
  ogImage: `${OG_PATH}service-category-security-guarding-and-safety-services-sydney.jpg`,
  type: "website",
};

export const subCategoryObject = Object.fromEntries(
  Object.entries({
    category2Service1: { ...service1, ...tags1(metaTags) },
    category2Service2: { ...service2, ...tags2(metaTags) },
    category2Service3: { ...service3, ...tags3(metaTags) },
    category2Service4: { ...service4, ...tags4(metaTags) },
    category2Service5: { ...service5, ...tags5(metaTags) },
  }).map(([key, value]) => [key, { ...value, headCategory }]),
);

const subCategories = Object.values(subCategoryObject);

export const categoryDetails: CategoryDetails = {
  ...headCategory,
  metaTags,
  order: 2,
  icon: UserCheck,
  description: [
    "Security guarding and safety support across Sydney, including licensed guards, mobile patrols, risk consultation, fire alarm support and security cabling. Ozy Wide Group scopes duties, access and reporting before recommending the right mix of people, systems and infrastructure.",
  ],
  points: guardingCategoryPoints,
  content: [
    {
      id: 1,
      title: "Security Guarding & Safety Services Sydney in Sydney",
      content:
        "Security guarding and safety support across Sydney, including licensed guards, mobile patrols, risk consultation, fire alarm support and security cabling. Ozy Wide Group scopes duties, access and reporting before recommending the right mix of people, systems and infrastructure.",
      points: [
        "Licensed guard and patrol support",
        "Risk reviews and site instructions",
        "Fire alarm and cabling coordination",
      ],
    },
  ],
  videos: [],
  images: createImageItems(
    images,
    "Security Guarding & Safety Services Sydney",
  ),
  subCategories,
};
